import { image } from '../../../utils/data/baseUrl';
import { defaultStore, stores, t } from '../../../translations';
import { rating as ratingData } from '../../../constants/copyright';
import {
  ONBOARDING_BUTTON_CALLBACKS,
  ONBOARDING_BUTTONS_CONDITION,
  ONBOARDING_IMAGE_CONDITIONS,
  ONBOARDING_MODAL_TYPES,
  ONBOARDING_STEPS_TYPES,
} from '../constants';

const { reward } = ratingData;
const ratingRewards = reward(t);

const onboardingModals = (elfName = '') => [
  {
    id: ONBOARDING_STEPS_TYPES.START,
    type: ONBOARDING_MODAL_TYPES.ONBOARDING_MODAL,
    props: {
      image: image('onboarding/start.png'),
      title: 'onboarding.start.title',
      description: t('onboarding.start.text', { elfName }),
      buttons: [
        {
          attr: {
            callbackKey: ONBOARDING_BUTTON_CALLBACKS.START,
            modalData: { action: 'close', data: { type: 'current' } },
            disposable: true,
            className: 'custom-button_green',
            text: 'onboarding.start.onboarding',
          },
        },
        {
          attr: {
            callbackKey: [ONBOARDING_BUTTON_CALLBACKS.RESET, ONBOARDING_BUTTON_CALLBACKS.SHOW_USER_MODALS],
            modalData: { action: 'close', data: { type: 'current' } },
            disposable: true,
            className: 'custom-button_gray',
            text: 'onboarding.start.skip',
            condition: ONBOARDING_BUTTONS_CONDITION.NOT_NEW_USER,
          },
        },
      ],
    },
  },
  {
    id: ONBOARDING_STEPS_TYPES.ACTIVITY,
    type: ONBOARDING_MODAL_TYPES.SLIDE_MODAL,
    props: {
      slides: [
        {
          title: 'onboarding.activity.0.title',
          text: ['onboarding.activity.0.text'],
          buttons: [
            {
              attr: {
                text: 'onboarding.activity.0.button',
              },
              action: 'next',
            },
          ],
          img: image('onboarding/activity-first-slide.png'),
          imgByCondition: [
            {
              condition: ONBOARDING_IMAGE_CONDITIONS.HIDE_SECTIONS_2026_ME,
              image: image('onboarding/activity-first-slide-me.png'),
            },
            {
              condition: ONBOARDING_IMAGE_CONDITIONS.HIDE_SECTIONS_2026_CIS,
              image: image('onboarding/activity-first-slide-cis.png'),
            },
          ],
        },
        {
          title: 'onboarding.activity.1.title',
          text: ['onboarding.activity.1.text'],
          buttons: [
            {
              attr: {
                callbackKey: [ONBOARDING_BUTTON_CALLBACKS.UPDATE, ONBOARDING_BUTTON_CALLBACKS.SHOW_USER_MODALS],
                modalData: { action: 'close', data: { type: 'current' } },
                disposable: true,
                text: 'onboarding.activity.1.button',
              },
            },
          ],
          img: image('onboarding/activity-second-slide.png'),
          imgByCondition: [
            {
              condition: ONBOARDING_IMAGE_CONDITIONS.HIDE_SECTIONS_2026_ME,
              image: image('onboarding/activity-second-slide-me.png'),
            },
            {
              condition: ONBOARDING_IMAGE_CONDITIONS.HIDE_SECTIONS_2026_CIS,
              image: image('onboarding/activity-second-slide-cis.png'),
            },
          ],
        },
      ],
      mod: 'onboarding',
    },
  },
  {
    id: ONBOARDING_STEPS_TYPES.CHALLENGES,
    type: ONBOARDING_MODAL_TYPES.ONBOARDING_MODAL,
    props: {
      image: image('onboarding/challenges.png'),
      imageByCondition: [
        {
          condition: ONBOARDING_IMAGE_CONDITIONS.HIDE_SECTIONS_2026_ME,
          image: image('onboarding/challenges_me.png'),
        },
        {
          condition: ONBOARDING_IMAGE_CONDITIONS.HIDE_SECTIONS_2026_CIS,
          image: image('onboarding/challenges_cis.png'),
        },
      ],
      title: 'onboarding.challenges.title',
      description: 'onboarding.challenges.text',
      buttonsMarginSize: 'large',
      buttons: [
        {
          attr: {
            callbackKey: ONBOARDING_BUTTON_CALLBACKS.UPDATE,
            modalData: { action: 'close', data: { type: 'current' } },
            disposable: true,
            text: 'onboarding.challenges.button',
          },
        },
      ],
    },
  },
  {
    id: ONBOARDING_STEPS_TYPES.BEAUTY_ROUTINE,
    type: ONBOARDING_MODAL_TYPES.ONBOARDING_MODAL,
    props: {
      textContainerSize: 'small',
      image: image('onboarding/beauty-routine.png'),
      title: 'onboarding.beautyRoutine.title',
      description: 'onboarding.beautyRoutine.text',
      buttons: [
        {
          attr: {
            callbackKey: ONBOARDING_BUTTON_CALLBACKS.UPDATE,
            modalData: { action: 'close', data: { type: 'current' } },
            disposable: true,
            className: 'custom-button_green',
            text: 'onboarding.beautyRoutine.button',
          },
        },
      ],
    },
  },
  {
    id: ONBOARDING_STEPS_TYPES.ACHIEVEMENTS,
    type: ONBOARDING_MODAL_TYPES.SLIDE_MODAL,
    props: {
      slides: [
        {
          title: 'onboarding.achievements.0.title',
          text: ['onboarding.achievements.0.text'],
          buttons: [
            {
              attr: {
                text: 'onboarding.achievements.0.button',
              },
              action: 'next',
            },
          ],
          img: image('onboarding/achievements-first-slide.png'),
        },
        {
          title: 'onboarding.achievements.1.title',
          text: ['onboarding.achievements.1.text'],
          buttons: [
            {
              attr: {
                callbackKey: [ONBOARDING_BUTTON_CALLBACKS.UPDATE, ONBOARDING_BUTTON_CALLBACKS.SHOW_ACHIEVEMENTS_TAB],
                modalData: { action: 'close', data: { type: 'current' } },
                disposable: true,
                text: 'onboarding.achievements.1.button',
              },
            },
          ],
          img: image('onboarding/achievements-second-slide.png'),
          imgByCondition: [
            {
              condition: ONBOARDING_IMAGE_CONDITIONS.HIDE_SECTIONS_2026_CIS,
              image: image('onboarding/achievements-second-slide-default.png'),
            },
            {
              condition: ONBOARDING_IMAGE_CONDITIONS.HIDE_SECTIONS_2026_ME_RU,
              image: image('onboarding/achievements-second-slide-me-ru.png'),
            },
            {
              condition: ONBOARDING_IMAGE_CONDITIONS.HIDE_SECTIONS_2026_ME_INTL,
              image: image('onboarding/achievements-second-slide-me-intl.png'),
            },
          ],
        },
      ],
      mod: 'onboarding',
    },
  },
  {
    id: ONBOARDING_STEPS_TYPES.CUSTOMIZATION,
    type: ONBOARDING_MODAL_TYPES.ONBOARDING_MODAL,
    props: {
      image: image('onboarding/customization.png'),
      title: 'onboarding.customization.title',
      description: 'onboarding.customization.text',
      buttons: [
        {
          attr: {
            callbackKey: ONBOARDING_BUTTON_CALLBACKS.UPDATE,
            modalData: { action: 'close', data: { type: 'current' } },
            disposable: true,
            className: 'custom-button_green',
            text: 'onboarding.customization.button',
          },
        },
      ],
    },
  },
  {
    id: ONBOARDING_STEPS_TYPES.ROADMAP,
    type: ONBOARDING_MODAL_TYPES.ONBOARDING_MODAL,
    props: {
      textContainerSize: 'small',
      image: image('onboarding/roadmap.png'),
      title: 'onboarding.roadmap.title',
      description: 'onboarding.roadmap.text',
      buttons: [
        {
          attr: {
            callbackKey: [ONBOARDING_BUTTON_CALLBACKS.UPDATE, ONBOARDING_BUTTON_CALLBACKS.SHOW_ROADMAP],
            modalData: { action: 'close', data: { type: 'current' } },
            disposable: true,
            className: 'custom-button_green',
            text: 'other.ok',
          },
        },
      ],
    },
  },
  {
    id: ONBOARDING_STEPS_TYPES.GAMES,
    type: ONBOARDING_MODAL_TYPES.ONBOARDING_MODAL,
    props: {
      textContainerSize: 'small',
      image: image('onboarding/games.png'),
      title: 'onboarding.games.title',
      description: 'onboarding.games.text',
      buttons: [
        {
          attr: {
            callbackKey: ONBOARDING_BUTTON_CALLBACKS.UPDATE,
            modalData: { action: 'close', data: { type: 'current' } },
            disposable: true,
            className: 'custom-button_green',
            text: 'onboarding.games.button',
          },
        },
      ],
    },
  },
  {
    id: ONBOARDING_STEPS_TYPES.RATING,
    type: ONBOARDING_MODAL_TYPES.ONBOARDING_MODAL,
    props: {
      image:
        defaultStore === stores.kz || defaultStore === stores.ru
          ? image('onboarding/rating_cis.png')
          : image('onboarding/rating_me.png'),
      title: 'onboarding.rating.0.title',
      description: t('onboarding.rating.0.text', {
        firstPlace: ratingRewards.firstPlace,
        secondToFifthPlace: ratingRewards.secondToFifthPlace,
        sixthToTenthPlace: ratingRewards.sixthToTenthPlace,
        eleventhToTwentiethPlace: ratingRewards.eleventhToTwentiethPlace,
      }),
      buttons: [
        {
          attr: {
            callbackKey: ONBOARDING_BUTTON_CALLBACKS.UPDATE,
            modalData: { action: 'close', data: { type: 'current' } },
            disposable: true,
            text: 'onboarding.rating.0.button',
          },
        },
      ],
    },
  },
  {
    id: ONBOARDING_STEPS_TYPES.SHOPPING,
    type: ONBOARDING_MODAL_TYPES.ONBOARDING_MODAL,
    props: {
      image: image('onboarding/shopping.png'),
      title: 'onboarding.shopping.title',
      description: 'onboarding.shopping.text',
      buttons: [
        {
          attr: {
            callbackKey: ONBOARDING_BUTTON_CALLBACKS.UPDATE,
            modalData: { action: 'close', data: { type: 'current' } },
            disposable: true,
            className: 'custom-button_green',
            text: 'onboarding.shopping.button',
          },
        },
      ],
    },
  },
  {
    id: ONBOARDING_STEPS_TYPES.SHELF,
  },
  {
    id: ONBOARDING_STEPS_TYPES.BOXES,
  },
  {
    id: ONBOARDING_STEPS_TYPES.SHOP,
  },
  {
    id: ONBOARDING_STEPS_TYPES.PREM,
  },
];

export default onboardingModals;
